/**
 * @flow
 * @relayHash ebb527cdc0e6591f61af7bb9bc327d50
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type HttpStatusCategory_project$ref = any;
export type httpStatus_HttpStatusCategory_QueryVariables = {|
  host: string
|};
export type httpStatus_HttpStatusCategory_QueryResponse = {|
  +project: ?{|
    +$fragmentRefs: HttpStatusCategory_project$ref
  |}
|};
export type httpStatus_HttpStatusCategory_Query = {|
  variables: httpStatus_HttpStatusCategory_QueryVariables,
  response: httpStatus_HttpStatusCategory_QueryResponse,
|};
*/


/*
query httpStatus_HttpStatusCategory_Query(
  $host: String!
) {
  project(host: $host) {
    ...HttpStatusCategory_project
    id
  }
}

fragment HttpStatusCategory_project on Project {
  host
  crawls(offset: 0, limit: 1) {
    edges {
      cursor
      node {
        countHttp3xxRedirects
        countHttp4xxErrors
        countHttp5xxErrors
        countHttpInHttps
        countCrawlErrors
        id
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "host",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "host",
    "variableName": "host",
    "type": "String!"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "httpStatus_HttpStatusCategory_Query",
  "id": null,
  "text": "query httpStatus_HttpStatusCategory_Query(\n  $host: String!\n) {\n  project(host: $host) {\n    ...HttpStatusCategory_project\n    id\n  }\n}\n\nfragment HttpStatusCategory_project on Project {\n  host\n  crawls(offset: 0, limit: 1) {\n    edges {\n      cursor\n      node {\n        countHttp3xxRedirects\n        countHttp4xxErrors\n        countHttp5xxErrors\n        countHttpInHttps\n        countCrawlErrors\n        id\n      }\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "httpStatus_HttpStatusCategory_Query",
    "type": "RootQuery",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "project",
        "storageKey": null,
        "args": v1,
        "concreteType": "Project",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "HttpStatusCategory_project",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "httpStatus_HttpStatusCategory_Query",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "project",
        "storageKey": null,
        "args": v1,
        "concreteType": "Project",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "host",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "crawls",
            "storageKey": "crawls(limit:1,offset:0)",
            "args": [
              {
                "kind": "Literal",
                "name": "limit",
                "value": 1,
                "type": "Int"
              },
              {
                "kind": "Literal",
                "name": "offset",
                "value": 0,
                "type": "Int"
              }
            ],
            "concreteType": "CrawlsConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "CrawlsEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "cursor",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Crawl",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "countHttp3xxRedirects",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "countHttp4xxErrors",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "countHttp5xxErrors",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "countHttpInHttps",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "countCrawlErrors",
                        "args": null,
                        "storageKey": null
                      },
                      v2
                    ]
                  }
                ]
              }
            ]
          },
          v2
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'b45aa3b287c385869cc0716ceb4c6895';
module.exports = node;
